<template>
  <div class="container my-2" style="max-width: 1000px">
    <SimuladorStep :step="2" :valor="plano.valorMensal" :periodicidade="plano.modeloCobranca.periodicidade">
    </SimuladorStep>
    <div class="d-flex row mt-1">
      <div class="col shadow m-3">
        <form @submit.prevent="continuar()" class="m-1">
          <div class="row mb-3">
            <span class="text-center m-1">
              <small>
                Para continuar, insira ou atualize, por favor, as informações adicionais para geração de contrato e
                exigências
                legais.
              </small>
            </span>
          </div>
          <div class="row mb-3">
            <div class="col-sm-6 mt-1">
              <label for="usuario" class="form-label">CPF</label>
              <input disabled class="form-control" type="text" id="usuario" placeholder="000.000.000-00"
                v-model="dadosConta.pessoa.cpf" v-mask="['###.###.###-##', '##.###.###/####-##']" required />
            </div>

            <div class="col-sm-6 mt-1">
              <label for="usuario" class="form-label">Matrícula</label>
              <input class="form-control" type="text" id="usuario" placeholder=""
                v-model="dadosConta.pessoa.registroAssociacao1" />
            </div>


            <div class="col-sm-6 mt-1">
              <label for="usuario" class="form-label">Nome Completo</label>
              <input class="form-control" type="text" id="usuario" placeholder="000.000.000-00"
                v-model="dadosConta.pessoa.nome" required />
            </div>
            <div class="col-sm-6 mt-1">
              <label for="usuario" class="form-label">E-mail</label>
              <input class="form-control" type="text" id="usuario" placeholder="" v-model="dadosConta.pessoa.email"
                required />
            </div>
            <div class="col-sm-6 mt-1">
              <label for="dataNascimento" class="form-label">Data de nascimento</label>
              <input class="form-control" v-model="dataNasc" placeholder="00/00/0000" id="dataNascimento"
                format="DD/MM/YYYY" v-mask="'##/##/####'" required pattern=".{10}" />
            </div>
            <div class="col-sm-6 mt-1">
              <label for="enderecoCep" class="form-label">Informe o CEP</label>
              <input @blur="getByCep()" class="form-control" type="text" id="enderecoCep" placeholder="00000-00"
                v-model="dadosConta.pessoa.endereco.cep" v-mask="['#####-###']" />
              <small class="text-muted" v-if="loadingCep">
                <span class="spinner-border spinner-border-sm"></span>
                Buscando seu CEP
                <span class="button-loader grey ml-2"></span>
              </small>
              <small class="text-danger" v-if="cepNaoLocalizado">CEP não localizado</small>
            </div>

            <div class="col-sm-6 mt-1">
              <label for="enderecoUf" class="form-label">UF</label>
              <input disabled class="form-control" type="text" id="enderecoUf"
                v-model="dadosConta.pessoa.endereco.estado" />
            </div>

            <div class="col-sm-6 mt-1">
              <label for="enderecoCidade" class="form-label">Cidade</label>
              <input disabled class="form-control" type="text" id="enderecoCidade"
                v-model="dadosConta.pessoa.endereco.cidade" />
            </div>


            <div class="col-sm-6 mt-1">
              <label for="enderecoBairro" class="form-label">Bairro</label>
              <input disabled class="form-control" type="text" id="enderecoBairro"
                v-model="dadosConta.pessoa.endereco.bairro" />
            </div>

            <div class="col-sm-6 mt-1">
              <label for="enderecoLogradouro" class="form-label">Endereço</label>
              <input disabled class="form-control" type="text" id="enderecoLogradouro"
                v-model="dadosConta.pessoa.endereco.endereco" />
            </div>
            <div class="col-sm-6 mt-1">
              <label for="enderecoNumero" class="form-label">Número </label>
              <input class="form-control" type="text" id="enderecoNumero" v-model="dadosConta.pessoa.endereco.numero" />
            </div>
            <div class="col-sm-6 mt-1">
              <label for="enderecoComplemento" class="form-label">Complemento </label>
              <input class="form-control" type="text" id="enderecoComplemento"
                v-model="dadosConta.pessoa.endereco.complemento" />
            </div>

            <div class="col-sm-12 mt-2">

              <p class="m-1">
                <input type="checkbox" v-model="aceiteTermos" data-bs-toggle="modal" data-bs-target="#exampleModal"
                  @click="aceiteTermos = !aceiteTermos" />
                <a href="#" data-bs-toggle="modal" data-bs-target="#exampleModal">
                  Li e concordo com os termos do contrato.
                </a>
              </p>

            </div>


          </div>
          <div v-if="erro" class="card my-2 badge-danger text-center p-3 text-uppercase m-3">
            {{ erro }}
          </div>
          <div class="mt-2 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">
            <button type="button" class="btn btn_color_system py-2 px-5 mt-4" @click="$router.go(-1)">
              VOLTAR
            </button>
            <button class="btn btn_color_system py-2 px-5 mt-4" type="submit">
              CONTINUAR
            </button>
          </div>
        </form>

      </div>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-full">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Termos e condições</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
          </div>
          <div class="modal-body">
            <div class="modal-body-full" v-html="this.plano.termos"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn_color_system" @click="aceiteTermos = true"
              data-bs-dismiss="modal">Aceitar</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
              @click="aceiteTermos = false">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading" :textoMensagem="mensagemLoading"></Loading>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import SimuladorStep from "@/components/assinaturas/SimuladorStep.vue";

import { APIService } from "../../APIService";
const apiService = new APIService();

// import { SimuladorService } from "../../service/assinatura/SimuladorService";
// const simuladorService = new SimuladorService();

export default {
  name: "SimuladorStep2",
  props: [],
  components: { Loading, SimuladorStep },
  data() {
    return {
      loading: true,
      mensagemLoading: "",
      plano: {
        modeloCobranca: {}
      },
      erro: null,
      dataNasc: null,
      dadosConta: {
        pessoa: {
          endereco: {
            cep: null,
            estado: null,
            cidade: null,
            bairro: null,
            endereco: null,
            numero: null,
            complemento: null,
          }
        }
      },
      cepCobranca: "0",
      loadingCep: false,
      cepNaoLocalizado: false,
      aceiteTermos: false
    }
  },
  mounted() {
    const _plano = localStorage.getItem("simulacao-plano");
    if (_plano) {
      this.plano = JSON.parse(_plano);
    }

    this.obterDados();
  },
  methods: {

    continuar() {
      this.erro = ""
      if (!this.aceiteTermos) {
        this.erro = "Você precisa aceitar os termos do contrato para continuar!";
      } else {

        this.loading = true;
        this.mensagemLoading = "Estamos atualizando seus dados. Por favor, aguarde um momento."
        const dateSplit = this.dataNasc.split("/");
        this.dadosConta.pessoa.dataNascimento = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;

        apiService
          .atualizarConta(this.dadosConta)
          .then(() => {
            this.$router.push(`/planos/simulador-step-3`);
            this.loading = false;
            window.scrollTo(0, 0);
          })
          .catch(error => {
            this.erro = error.response.data.title;
            this.loading = false;
            window.scrollTo(0, 0);
          });
      }
    },

    obterDados() {
      this.loading = true;
      apiService.dadosApp().then((res) => {
        this.dadosConta = res;

        const _cadastro = localStorage.getItem("dados-cadastro");
        if (_cadastro) {
          const register = JSON.parse(_cadastro);
          this.dadosConta.pessoa.nome = register.nome + ' ' + register.sobrenome
          this.dadosConta.pessoa.email = register.email;
          const dateSplit = this.dadosConta.pessoa.dataNascimento.split("-");
          this.dataNasc = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0]}`;

          console.log(this.dataNasc)
        } else {
          const dateSplit = this.dadosConta.pessoa.dataNascimento.split("-");
          this.dataNasc = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0]}`;

        }
        if (!this.dadosConta.pessoa.endereco) {
          this.dadosConta.pessoa.endereco = {
            cep: null,
            estado: null,
            cidade: null,
            bairro: null,
            endereco: null,
            numero: null,
            complemento: null,
          }
        }

        this.loading = false;
      }).catch(error => {
        this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title;
        this.loading = false;
        window.scrollTo(0, 0);
      });
    },
    getByCep() {

      this.cepNaoLocalizado = false;
      if (!this.loadingCep && this.dadosConta.pessoa.endereco.cep && this.dadosConta.pessoa.endereco.cep.length >= 8) {
        this.loading = true;
        apiService
          .getCep(this.dadosConta.pessoa.endereco.cep)
          .then(res => {
            if (res) {
              this.dadosConta.pessoa.endereco = res;
              this.loading = false;
            } else {
              this.loading = false;
              this.cepNaoLocalizado = true;
            }
          })
          .catch(() => {
            this.loading = false;
            this.cepNaoLocalizado = true;
          });

      }
    },
  },
};
</script>

<style scoped>
.texto-aviso {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 45px;

}

.card-form {
  background-color: #BDB6B6;
}
</style>
